import React from 'react';
import { Modal } from 'react-bootstrap';
import { useOnboarding } from '../../context/OnboardingContext';
import Logo from '../../assets/images/myfx-logo.png';
import './Onboarding.css';

const WelcomeModal: React.FC = () => {
    const { showWelcomeModal, startTour, skipOnboarding } = useOnboarding();

    return (
        <Modal
            show={showWelcomeModal}
            centered
            size="sm"
            backdrop="static"
            keyboard={false}
            dialogClassName="onb-welcome-modal"
            backdropClassName="onb-welcome-backdrop"
            onHide={skipOnboarding}
        >
            <Modal.Body>
                {/* Decorative sparkles */}
                <div className="onb-sparkle-container">
                    <span className="onb-sparkle" />
                    <span className="onb-sparkle" />
                    <span className="onb-sparkle" />
                    <span className="onb-sparkle" />
                    <span className="onb-sparkle" />
                    <span className="onb-sparkle" />
                </div>

                <img src={Logo} alt="Falchion Xenia" className="onb-welcome-logo" />

                <h2 className="onb-welcome-heading">Welcome to Falchion Xeniaa!</h2>

                <p className="onb-welcome-subtext">
                    Your all-in-one restaurant management platform. Let us give you
                    a quick tour of the key features to get you started.
                </p>

                {/* <div className="onb-feature-pills">
                    {FEATURES.map((f) => (
                        <span key={f.label} className="onb-feature-pill">
                            {f.icon} {f.label}
                        </span>
                    ))}
                </div> */}

                <button className="onb-start-btn" onClick={startTour}>
                    🚀 Start Tour
                </button>

                <button className="onb-skip-btn" onClick={skipOnboarding}>
                    Skip for now
                </button>
            </Modal.Body>
        </Modal>
    );
};

export default WelcomeModal;
